import _ from 'underscore';

window._ = _;
